<template>
    <b-row>
        <div class="col-sm-12 mt-1">
            <h3>
                Crear motivo
            </h3>
        </div>
        <div class="col-sm-8 mt-3">
            <label for="" class="form-label">Motivo</label>
            <input type="text" id="campo_motivo" autocomplete="off" class="form-control form-control-sm"
                v-model="motivo">
        </div>
        <div class="col-sm-4 mt-5">
            <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                v-if="permisos['inventarios.movimientos.salidas.motivos']?.crear || ES_ROOT"
                @click="guardar_motivo">Guardar</button>
            <button type="button" class="btn btn-sm btn-outline-dark btn-block" v-else disabled>Guardar</button>
        </div>
        <div class="col-sm-12 mt-3 mb-3">
            <div class="marco_modal_crear_motivos">
                <table class="table table-sm table-striped table-bordered" style="font-size: 10px;">
                    <thead>
                        <tr>
                            <th style="width: 85%;">
                                Motivo
                            </th>
                            <th style="width: 15%;text-align: center;">
                                ...
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in motivos_salida" :key="index">
                            <td>
                                {{ item.motivo }}
                            </td>
                            <td style="text-align: center;">
                                <button type="button" style="font-size: 9px;margin-right: 5px;"
                                    class="btn btn-sm btn-outline-dark"
                                    v-if="permisos['inventarios.movimientos.salidas.motivos']?.borrar || ES_ROOT"
                                    @click="elimiar_registro(item.documentId)"><i class="fas fa-trash"></i></button>
                                <button type="button" style="font-size: 9px;margin-right: 5px;"
                                    class="btn btn-sm btn-outline-dark" v-else disabled><i
                                        class="fas fa-trash"></i></button>

                                <button type="button" style="font-size: 9px;" class="btn btn-sm btn-outline-dark"
                                    v-if="permisos['inventarios.movimientos.salidas.motivos']?.actualizar || ES_ROOT"
                                    @click="abrir_editar_motivo(item)"><i class="fas fa-pen"></i></button>
                                <button type="button" style="font-size: 9px;" class="btn btn-sm btn-outline-dark" v-else
                                    disabled><i class="fas fa-pen"></i></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </b-row>

</template>

<script>
    import { minix, pregunta } from '@/components/functions/alertas';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

    export default {
        name: 'CrearMotivos',
        computed: {
            ...mapState(['motivos_salida', 'permisos', 'datos_usuario']),
            ...mapGetters(['ES_ROOT'])
        },
        data() {
            return {
                motivo: ''
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            async guardar_motivo() {
                if (this.motivo !== '') {
                    let f = {
                        api: `motivo-salidas`,
                        formulario: {
                            motivo: this.motivo.toUpperCase().trim()
                        }
                    }

                    await this.guardar_data(f)
                    await this.obtener_motivos_salidas()


                    this.motivo = ''

                } else {
                    minix({ icon: 'error', mensaje: 'Todos los campos son obligatorios', tiempo: 3000 })
                    document.getElementById('campo_motivo').focus()
                }

            },
            abrir_editar_motivo(item) {
                this.set_motivo_seleccionado(item)
                this.$emit('actualizar_modulo')
            },
            async elimiar_registro(documentId) {
                pregunta({ titulo: 'Seguro que deseas borrar el registro?', texto: 'Estaacción no se puede revertir', afirmacion: 'Si, borrar!' }, async (i) => {
                    if (i) {
                        let f = {
                            api: `motivo-salidas/${documentId}`,
                        }

                        await this.borrar_data(f)
                        await this.obtener_motivos_salidas()

                    }
                })
            },
            ...mapActions(['guardar_data', 'obtener_motivos_salidas', 'borrar_data']),
            ...mapMutations(['set_motivo_seleccionado'])
        },
        mounted() {
            document.getElementById('campo_motivo').focus()
            this.obtener_motivos_salidas()
        },
    }
</script>

<style>
    .marco_modal_crear_motivos {
        width: 100%;
        height: 300px;
        overflow: auto;
    }
</style>